import { Component } from '@angular/core';
import { Feedback } from '../../models/feedback.model';
import { CommonModule } from '@angular/common';
import { TitleService } from '../../services/title.service';

@Component({
    selector: 'app-feedback',
    imports: [CommonModule],
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.css'
})
export class FeedbackComponent {

  currentFeedIndex: number = 0;
  constructor(private ts : TitleService) {
  }
  ngOnInit(){
    this.ts.titolo = "Feedback";
  }

  feedbacks : Array<Feedback> = [
    {testo: "È più di un anno che frequento questa palestra e devo dire che gli obiettivi che avevo condiviso con Matteo e Jacopo sono stati di gran lunga raggiunti. Disponibilità, collaborazione e professionalità, sono veramente una garanzia! Ho trovato quella motivazione che non riuscivo ad avere in altre palestre. Super contenta di essere entrata a far parte di questa “famiglia” di folli. Il sorriso è assicurato! Super consigliata.", cliente: "Alessandra"},
    {testo: "La palestra sottocasa che diventa spazio dove potersi allenare senza il caos delle grandi palestre e con personale sempre in tuo supporto. È al contempo uno spazio dove poter staccare e trovare momento di svago. Consigliatissima!", cliente: "Monica"},
    {testo: "Oltre ad essere un'ottima palestra è una grande famiglia dove potersi allenare in armonia senza rinunciare alla qualità. Personale molto qualificato e sempre disponibile. Il top", cliente: "Michele"},
    {testo: "Palestra eccezionale così come tutto lo staff…ci si allena con impegno e ci si diverte sempre! Allenandosi con costanza, e con i consigli dei nostri Personal si vedono i risultati!!! Consigliatissimi!!!", cliente: "Eleonora"},
    {testo: "In assoluto i migliori! Con dei personal trainer così disponibili (e non è mai scontato) e preparati, mi è tornata la voglia di allenarmi senza mollare! ", cliente: "Francesca"},
    {testo: "Ricominciare a fare sport dopo anni, con le mie condizioni di salute iniziali, è stata una sfida. Sfida che solo Matteo ha vinto, dopo anni in cui mi sono allenata e poi sempre fermata per problemi osteoarticolari post-allenamento. Inizio a vedere i primi risultati, o meglio ''a sentirli'' fuori e soprattutto dentro. Ormai la palestra è la mia seconda family. Vi voglio bene", cliente: "Silvia"}
  ];

  getPrevious() {
    console.log("Voglio il precedente");
    if(this.currentFeedIndex == 0) {
      console.log(this.feedbacks.length);
      this.currentFeedIndex = this.feedbacks.length-1;
    } else {
      this.currentFeedIndex = this.currentFeedIndex -1;
    }
  }

  getNext() {
    console.log("Voglio il successivo");
    if(this.currentFeedIndex == this.feedbacks.length-1) {
      console.log(this.feedbacks.length);
      this.currentFeedIndex = 0;
    } else {
      this.currentFeedIndex = this.currentFeedIndex +1;
    }
  }
}
